import React from "react";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
  const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 1.2s ease;
  border-radius: 1000px;
  padding: 24px 40px;
  text-align: center;
  font-family: 'Inter';
  font-weight: 700;
  width: fit-content;
  margin: auto auto 8px;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
      padding: 32px 48px;
  }
  .label{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;

const SingleBar = ({
  color,
  height,
  inView,
  value,
  label,
  lineColor = color
}) => (
  <div style={{ maxWidth: "280px", width: "100%" }}>
    <AnimatedDiv inView={inView}>
      <div>{value}</div>
      <div className="label">{label}</div>
    </AnimatedDiv>
    {/* Linje mellan bubbla och stapel */}
    <div
      style={{
        width: "1px",
        height: inView ? "24px" : "0px",
        background: "#000",
        margin: "0 auto",
        opacity: inView ? 1 : 0,
        transition: "height 1.2s ease, opacity 1.2s"
      }}
    ></div>
    {/* Stapel */}
    <div
      style={{
        width: "100%",
        height: height,
        background: color,
        marginTop: "8px",
        opacity: inView ? 1 : 0,
        transform: inView && height !== "0px" ? "scaleY(1)" : "scaleY(0)",
        transformOrigin: "bottom",
        transition: "transform 1.2s ease, opacity 1.2s"
      }}
    ></div>
  </div>
);

export default SingleBar;
